// extracted by mini-css-extract-plugin
export var banner = "_p2-0";
export var settingRow = "_p2-2";
export var titleIcon = "_p2-1";